import { productsSlugs } from 'constants/products';

import cleanser from 'assets/images/productPages/prose-custom-cleanser.jpg';
import conditioner from 'assets/images/productPages/prose-custom-conditioner.jpg';
import curlCream from 'assets/images/productPages/prose-custom-curl-cream.jpg';
import dryShampoo from 'assets/images/productPages/prose-custom-dry-shampoo.jpg';
import hairOil from 'assets/images/productPages/prose-custom-hair-oil.jpg';
import leaveInConditioner from 'assets/images/productPages/prose-custom-leave-in-conditioner-spray-top.jpg';
import moisturizer from 'assets/images/productPages/prose-custom-moisturizer.jpg';
import hairMask from 'assets/images/productPages/prose-custom-pre-shampoo-hair-mask.jpg';
import scalpMask from 'assets/images/productPages/prose-custom-pre-shampoo-scalp-mask.jpg';
import serum from 'assets/images/productPages/prose-custom-serum.jpg';
import shampoo from 'assets/images/productPages/prose-custom-shampoo.jpg';
import stylingGel from 'assets/images/productPages/prose-custom-styling-gel.jpg';
import supplements from 'assets/images/productPages/prose-model-holding-custom-root-source-hair-supplements.jpg';

const productsStucturedData = {
  [productsSlugs.CONDITIONER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Conditioner',
    image: conditioner.src,
    description:
      'Personalized to your unique hair, Prose Custom Conditioner is a nourishing formula to smooth, soften, and hydrate. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-conditioner',
        priceCurrency: 'USD',
        price: '35.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-conditioner',
        priceCurrency: 'USD',
        price: '29.75',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.CURL_CREAM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Curl Cream',
    image: curlCream.src,
    description:
      'Personalized to your natural texture, Prose Custom Curl Cream keeps curls, coils, and waves hydrated and frizz-free. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-curl-cream',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-curl-cream',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.DRY_SHAMPOO]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Dry Shampoo',
    image: dryShampoo.src,
    description:
      'Refresh your roots with Prose Custom Dry Shampoo — a non-aerosol formula personalized to your unique scalp needs. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-dry-shampoo',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-dry-shampoo',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.HAIR_MASK]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Pre-Shampoo Hair Mask',
    image: hairMask.src,
    description:
      'Restore moisture and shine with Prose Custom Hair Mask — a pre-shampoo treatment personalized to your unique goals. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-mask',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-mask',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.HAIR_OIL]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Hair Oil',
    image: hairOil.src,
    description:
      'Shop Prose Custom Hair Oil — a nurturing, silicone-free formula with natural oils to smooth, tame, and restore hair. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.OIL]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Hair Oil',
    image: hairOil.src,
    description:
      'Shop Prose Custom Hair Oil — a nurturing, silicone-free formula with natural oils to smooth, tame, and restore hair. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-oil',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.LEAVEIN_CONDITIONER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Leave-In Conditioner',
    image: leaveInConditioner.src,
    description:
      'Hydrate, detangle, and protect hair from heat styling damage up to 450°F with Prose Custom Leave-In Conditioner. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-leave-in-conditioner',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-leave-in-conditioner',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SCALP_MASK]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Pre-Shampoo Scalp Mask',
    image: scalpMask.src,
    description:
      'Purify, soothe, and restore scalp balance with Prose Custom Scalp Mask. Fragrance-free + suitable for sensitive scalps. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-mask',
        priceCurrency: 'USD',
        price: '49.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-mask',
        priceCurrency: 'USD',
        price: '41.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SHAMPOO]: [
    {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: 'Custom Shampoo',
      image: shampoo.src,
      description:
        'Custom shampoo made-to-order for your unique hair needs based on a personal consultation.',
      brand: {
        '@type': 'Brand',
        name: 'Prose Haircare',
      },
      offers: [
        {
          '@type': 'Offer',
          price: '14.00',
          priceCurrency: 'USD',
          url: 'https://prose.com/products/custom-shampoo?offer=60off',
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD',
            },
            shippingLabel: 'Promotional 60% Off + Free Shipping',
            shippingDestination: {
              '@type': 'DefinedRegion',
              addressCountry: 'US',
            },
          },
          hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
            returnFees: 'https://schema.org/FreeReturn',
          },
        },
        {
          '@type': 'Offer',
          price: '35.00',
          priceCurrency: 'USD',
          url: 'https://prose.com/products/custom-shampoo',
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '6.95',
              currency: 'USD',
            },
            shippingLabel: 'Standard Shipping (Non-Subscription)',
            shippingDestination: {
              '@type': 'DefinedRegion',
              addressCountry: 'US',
            },
          },
          hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
            returnFees: 'https://schema.org/FreeReturn',
          },
        },
        {
          '@type': 'Offer',
          price: '29.75',
          priceCurrency: 'USD',
          url: 'https://prose.com/products/custom-shampoo',
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock',
          shippingDetails: {
            '@type': 'OfferShippingDetails',
            shippingRate: {
              '@type': 'MonetaryAmount',
              value: '0.00',
              currency: 'USD',
            },
            shippingLabel: 'Free Shipping (Subscription)',
            shippingDestination: {
              '@type': 'DefinedRegion',
              addressCountry: 'US',
            },
          },
          hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
            returnFees: 'https://schema.org/FreeReturn',
          },
        },
      ],
      review: [
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Carmen V.',
          },
          datePublished: '2024-10-22',
          reviewBody: `I'm super happy with my shampoo formula. My hair gets clean even without being stripped and it's gentle on my color treated hair. I find I don't have to use a ton of product to get a proper lather and good coverage on my strands even as they lengthen. My hairstylist has asked me to remind her of the product I've been using because she likes how healthy my hair has looked. So please know this formula is definitely spot on.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Olivia P.',
          },
          datePublished: '2024-03-13',
          reviewBody: `I love the shampoo. My hair feels soft and clean. I use demi-permanant hair color that slowly washes out, so I avoid harsh roots. Salon brands would wash the color out quickly, but my Prose shampoo is making my color last longer, and look richer.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Hana E.',
          },
          datePublished: '2024-03-15',
          reviewBody: `This is amazing. I really tried everything else, every professional brand, and spent hundreds per bottle, but Prose is made with REAL ingredients and causes absolutely no damage. My hair is smooth, no frizz. It’s way beyond any hydrating I’ve ever gotten from any other shampoo. I’m speechless right now. I’m just mad at myself I didn’t try this sooner and wasted so much money on different brands. Prose, you saved my hair, my confidence has been through the roof. I can’t thank you enough!!`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Ashley L.',
          },
          datePublished: '2024-03-06',
          reviewBody: `My husband loves running his fingers through my long hair, and since I’ve been using it, he can’t quit touching my hair. He has always loved how my hair smells but now he loves sleeping on my pillow because it smells like my hair. Ladies, you won’t regret this investment. Not only will you love it, HE WILL LOVE IT AS WELL❤️`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Lauren T.',
          },
          datePublished: '2024-03-27',
          reviewBody: `Previously, my hair would lose curl throughout the day and be stringy on day 2. With Prose, I feel like I can still rock curls on day 2 without having to wash my hair every day. I do think it has helped tame frizz and maintain my curls for a longer period of time. Also, I LOVE the smell!`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Nicole B.',
          },
          datePublished: '2024-08-03',
          reviewBody: `I was super skeptical about Prose products working for me since I’d spent a crazy amount of money trying nearly every other hair product on the market with little to no results. I have been absolutely blown away by the positive changes with my hair since using Prose. My once frizzy, tangled, thinning, blah hair is now full and bouncy, and the healthiest it’s looked in YEARS. I have gotten so many compliments (including from my hairdresser!) on the condition of my hair and how amazing it’s looking. I don’t typically write reviews but I honestly can’t express enough how very happy I am with this product. The shampoo is super light, which made me worried it wasn’t going to suds up how I like, but it gets super sudsy and leaves my hair feeling all-the-way clean.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Isabel F.',
          },
          datePublished: '2024-09-06',
          reviewBody: `This is the first shampoo I’ve ever used in my adult life that hasn’t burned my scalp. On top of that, shampoo used to burn my scalp but I would STILL have flakiness and dandruff as soon as I got out of the shower, making me feel like it was all for naught. Not only does this shampoo take away all itchiness and flakiness I’ve always dealt with, but it is also the first time I’ve seen a pale normal colored scalp instead of inflamed red or pink. And dear god what kind of magic have you done to make it smell so god damn good?! Seriously, if I could bottle the smell up and use it for everything I would. Even after my hair has been dried for a day my husband would catch a whiff and say this is the best my hair has ever smelled. So thanks for that too! Please don’t ever stop making this shampoo because I think I’d die if I have to go back to itchy, inflamed, red scalp that doesn’t smell like the garden of Eden.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Monique D.',
          },
          datePublished: '2024-08-15',
          reviewBody: `I really like this shampoo. It lathers on very nicely. Following the directions as advised, I can see and feel the difference from just one wash!`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Marisol C.',
          },
          datePublished: '2024-07-19',
          reviewBody: `My hair feels cleaner for longer. Previously, my hair would start to feel oily and unclean 2 days after washing. Now, I can go 3 days, sometimes even 4, before it feels gross.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Maya L.',
          },
          datePublished: '2024-08-20',
          reviewBody: `I absolutely love this shampoo that is developed JUST FOR ME! I was always a salon shampoo buyer until I decided to try Prose. I am thrilled and will not go back.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Taylor C.',
          },
          datePublished: '2024-08-20',
          reviewBody: `I love the smell and the clean feeling it leaves. It lathers awesome for my almost waist-length hair.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '4',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Jordan M.',
          },
          datePublished: '2024-09-11',
          reviewBody: `The shampoo works wonders for giving me that clean-hair feeling without feeling stripped. However, my hair still feels dry midback and to the ends of my hair. It does have nice shine without being too shiny that it looks dirty. My hair still gets knotty and I have a bit of a dry scalp/some flakiness from time to time (unsure if weather is affecting that with seasons changing) with breakage at the ends. Overall, this shampoo is better than the cheap shampoo brand I used to use before using Prose Custom Shampoo for my hair.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '3',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Rachel N.',
          },
          datePublished: '2024-09-23',
          reviewBody: `The shampoo cleans well and keeps me oil-free for 2-3 days after washing, which is great. It doesn’t feel as hydrating as previous shampoo orders from Prose, but I believe that this may help with extended periods between washes and keeping oil down. Previous shampoo orders seemed to leave my hair feeling softer immediately after rinsing, while this one seems to be more "squeaky clean" feeling. Not much, but something I noticed. I think that if the conditioner had more slip and hydration to it, this particular shampoo formula may not be the problem.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '3',
            bestRating: '5',
          },
        },
        {
          '@type': 'Review',
          author: {
            '@type': 'Person',
            name: 'Allison A.',
          },
          datePublished: '2024-08-05',
          reviewBody: `My hair feels so wonderful! However, I would love more scalp soothing ingredients. The flakes are better. The itch is mildly better.`,
          name: `Prose Custom Shampoo`,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '3',
            bestRating: '5',
          },
        },
      ],
    },
    {
      '@context': 'https://schema.org/',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What shampoo should I use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Everyone’s hair is unique, and your shampoo should factor in your hair type, porosity, density, and the environmental stressors (like hard water, humidity and pollution) in your zip code. Prose asks in-depth questions about your diet, lifestyle, and climate, all of which impact your hair.',
          },
        },
        {
          '@type': 'Question',
          name: 'What type of hair is this shampoo for?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Prose custom haircare works on straight (type 1), wavy (type 2), curly (type 3) and coily (type 4) hair. Our completely personalized formulas account for different hair densities, porosities, textures, and types, so your hair can get the exact care that it needs.',
          },
        },
        {
          '@type': 'Question',
          name: 'How often should I wash my hair?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'How often you need to shampoo varies for each individual, since sebum (the natural oils your scalp produces) is impacted by external and internal factors. These factors range from pollution to humidity, and stress levels to hormones. Your personalized Prose formulas can help mitigate environmental stressors and provide the right targeted ingredients to help keep your hair and scalp balanced — which can mean more time between washes!',
          },
        },
        {
          '@type': 'Question',
          name: 'Will Prose shampoo help me go longer in between washes?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "This will vary for each individual, since sebum production is impacted by external and internal factors. These can range from pollution and humidity, to stress levels and hormones. Your personalized Prose formulas can help mitigate environmental stressors, but as for fixing stress levels — we're still working on it!",
          },
        },
        {
          '@type': 'Question',
          name: 'I have a sensitive scalp — can I still use Prose Custom Shampoo?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, our personalized shampoo aims to address scalp sensitivity with a gentle formula. Our shampoo can also be made fragrance-free, which we recommend for those who have sensitive skin. Remember, always consult a doctor if you’re experiencing a severe medical condition.',
          },
        },
        {
          '@type': 'Question',
          name: 'What ingredients should I avoid in shampoo?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Prose is not intended to treat medical conditions. Our formulas are a 100% drug-free alternative to prescription products and OTC (over-the-counter) medicines. Instead, we use only the highest quality, naturally powerful and proven-effective ingredients to enhance shine, volume, hair health, and so much more.',
          },
        },
        {
          '@type': 'Question',
          name: 'What is the best shampoo and conditioner to use together?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'For the best results, we recommend using Custom Shampoo and Custom Conditioner together to cleanse your scalp and hydrate your hair’s ends. Your hair may need different care on its lengths, and our Custom Shampoo and Custom Conditioner are uniquely formulated for your specific hair type and concerns, to provide personalized care from root to tip.',
          },
        },
      ],
    },
  ],
  [productsSlugs.STYLING_GEL]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Styling Gel',
    image: stylingGel.src,
    description:
      'Prose Custom Styling Gel is personalized for lightweight, flexible, flake-free hold — no matter your hairstyle. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-styling-gel',
        priceCurrency: 'USD',
        price: '32.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-styling-gel',
        priceCurrency: 'USD',
        price: '27.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SUPPLEMENT_CORE]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Hair Supplements',
    image: supplements.src,
    description:
      'Stimulate hair growth with Prose Custom Root Source® Hair Supplements made with natural, clean ingredients. Shop today for longer, stronger hair in 90 days.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-supplements',
        priceCurrency: 'USD',
        price: '64.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-hair-supplements',
        priceCurrency: 'USD',
        price: '54.40',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.CLEANSER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Cleanser',
    image: cleanser.src,
    description:
      'Shop Prose Custom Cleanser — a gentle face wash tailored to your skin type and proven to preserve skin hydration. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-cleanser',
        priceCurrency: 'USD',
        price: '29.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-cleanser',
        priceCurrency: 'USD',
        price: '24.65',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.MOISTURIZER]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Moisturizer',
    image: moisturizer.src,
    description:
      'Discover Prose Custom Moisturizer — a nourishing formula personalized with powerful, skin-boosting ingredients. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-moisturizer',
        priceCurrency: 'USD',
        price: '52.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-moisturizer',
        priceCurrency: 'USD',
        price: '44.20',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SERUM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Face Serum',
    image: serum.src,
    description:
      'Personalized with potent, clinically tested ingredients, Prose Custom Serum reveals hydrated, healthy-looking skin. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Skincare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-serum',
        priceCurrency: 'USD',
        price: '64.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-serum',
        priceCurrency: 'USD',
        price: '54.50',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
  [productsSlugs.SCALP_SERUM]: {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: 'Custom Scalp Serum',
    image: serum.src,
    description:
      'Shop Prose Custom Scalp Serum — a 99% natural formula to nourish your scalp and boost hair fullness and density. Always made to order. Always just for you.',
    brand: {
      '@type': 'Brand',
      name: 'Prose Haircare',
    },
    offers: [
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-serum',
        priceCurrency: 'USD',
        price: '56.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '6.95',
            currency: 'USD',
          },
          shippingLabel: 'Standard Shipping (Non-Subscription)',
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
      {
        '@type': 'Offer',
        url: 'https://prose.com/products/custom-scalp-serum',
        priceCurrency: 'USD',
        price: '28.00',
        itemCondition: 'https://schema.org/NewCondition',
        eligibleQuantity: {
          '@type': 'QuantitativeValue',
          value: 1,
        },
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: '0.00',
            currency: 'USD',
          },
          shippingLabel: 'Free Shipping (Subscription)',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
        },
        hasMerchantReturnPolicy: {
          '@type': 'MerchantReturnPolicy',
          url: 'https://prose.com/faq/5f3da05bceb96c001a595c02',
          returnFees: 'https://schema.org/FreeReturn',
        },
      },
    ],
  },
};

export default productsStucturedData;
